export const SNOWPACK_PUBLIC_API_URL = "https://mtvrudnv7d.execute-api.us-east-1.amazonaws.com/";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;